import { notification } from "antd";
import { SmileOutlined, FrownOutlined } from "@ant-design/icons";

export const errorMsg = (errorMsg, duration = 2) => {
  const msgKey = Math.random().toString();
  notification.open({
    message: "Алдаа",
    description: errorMsg ?? "Алдаа гарлаа",
    icon: (
      <FrownOutlined
        style={{
          color: "red",
        }}
      />
    ),
    placement: "top",
    top: 30,
    duration: duration,
    key: msgKey,
    onClick: () => notification.destroy(msgKey),
  });
};

export const successMsg = (successMsg, duration = 1) => {
  const msgKey = Math.random().toString();
  notification.open({
    message: "Амжилттай",
    description: successMsg ?? "Мэдээллийг амжилттай хадгаллаа.",
    icon: (
      <SmileOutlined
        style={{
          color: "#108ee9",
        }}
      />
    ),
    placement: "top",
    top: 30,
    duration: duration,
    key: msgKey,
    onClick: () => notification.destroy(msgKey),
  });
};
